exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!../../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-3!../../../assets/css/list.scss"), "");

// module
exports.push([module.id, "ul li[data-v-98df36ba]{width:240px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
